/* LTHR buy-box gate (CRO-11 2026-09-18; screws 2026-09-29).
   Holds Add to Cart until the shopper has made every required choice:
   1. Size. Dawn preselects the first available variant, so on a belt page
      Size reads "28" and a one-tap Add to Cart ships a 28. On product pages
      reached without ?variant= in the URL, this script puts a disabled
      "Select your size" placeholder at the top of the Size dropdown.
   2. Buckle screws (Analiese 9/29), when the page has the
      properties[Buckle screws] select from snippets/ntd-screw-select.liquid.
      The product form is novalidate, so its `required` alone would not stop
      an add.
   The button reads "Select Your Size", then "Choose Screw Type", then Add to
   Cart. data-ntd-gate-next ("size" / "screws") tells the sticky bar where to
   scroll.

   Dawn details this leans on:
   - variant-selects builds its fetch from option[selected] attributes and
     data-option-value-id, so the placeholder mirrors the default size's id;
     a Color or Edge change still resolves to a real variant server-side.
   - product-info replaces the picker markup after every variant change and
     resets the button, so the gate re-applies on PUB_SUB_EVENTS.variantChange.
     The screws select sits in its own block, which Dawn does not re-render,
     so its value survives variant changes.
   - The sticky CTA (ntd-product.js) mirrors the button's disabled state and
     label, and in guide mode scrolls to the next choice.

   LSC-156 (2026-10-05): Clarity logged 23 dead taps on the gated button in
   3 days; a natively disabled button ignores taps, so shoppers got no answer.
   The gate now uses aria-disabled (same look; Dawn's product-form also refuses
   to submit while aria-disabled) and a tap scrolls to the missing choice,
   outlines it and says what to pick (window.ntdGateGuide, also used by the
   sticky bar). The click is stopped in capture phase, before
   snippets/ntd-monogram.liquid can add its $10 line. */
(function () {
  if (window.ntdSizeGateInit) return;
  window.ntdSizeGateInit = true;

  var SIZE_LABEL = 'Select Your Size';
  var SCREWS_LABEL = 'Choose Screw Type';
  var PLACEHOLDER = 'Select your size';
  var SIZE_MSG = 'Choose your size to continue.';
  var SCREWS_MSG = 'Choose a screw type to continue.';
  // LSC-164 (2026-10-07): ad, Shopping and email links carry ?variant= too
  // (the Woodward video ad landed on Black / Stitched / 28), so a variant in
  // the URL only counts as a chosen size when no campaign parameter came with
  // it. Dawn rewrites the URL to a bare ?variant= once the shopper picks.
  var query = window.location.search;
  var sizeChosen = /[?&]variant=/.test(query) && !/[?&](utm_source|fbclid|gclid|gbraid|wbraid)=/.test(query);

  function sizeSelect() {
    return document.querySelector('variant-selects select[name="options[Size]"]');
  }

  function screwSelect() {
    return document.querySelector('select[name="properties[Buckle screws]"]');
  }

  function submitButton() {
    var sel = sizeSelect() || screwSelect();
    var formId = sel && sel.getAttribute('form');
    var form = formId && document.getElementById(formId);
    return (form && form.querySelector('.product-form__submit')) || document.querySelector('.product-form__submit');
  }

  function labelOf(btn) {
    return btn ? btn.querySelector('span:not(.loading__spinner)') : null;
  }

  function addPlaceholder() {
    var sel = sizeSelect();
    if (!sel || sel.querySelector('[data-ntd-size-placeholder]')) return;
    var current = sel.options[sel.selectedIndex];
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = PLACEHOLDER;
    ph.disabled = true;
    ph.setAttribute('data-ntd-size-placeholder', '');
    if (current) {
      if (current.dataset.optionValueId) ph.dataset.optionValueId = current.dataset.optionValueId;
      current.removeAttribute('selected');
    }
    ph.setAttribute('selected', 'selected');
    sel.insertBefore(ph, sel.firstChild);
    sel.selectedIndex = 0;
  }

  function refresh() {
    if (!sizeChosen && sizeSelect()) addPlaceholder();
    var screws = screwSelect();
    var next = !sizeChosen && sizeSelect() ? 'size' : screws && !screws.value ? 'screws' : null;
    var btn = submitButton();
    if (!btn) return;
    if (next !== 'size') clearGuide(sizeSelect());
    if (next !== 'screws') clearGuide(screws);
    var label = labelOf(btn);
    if (next) {
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('data-ntd-size-gate', '');
      btn.setAttribute('data-ntd-gate-next', next);
      if (label) label.textContent = next === 'size' ? SIZE_LABEL : SCREWS_LABEL;
    } else if (btn.hasAttribute('data-ntd-size-gate')) {
      btn.removeAttribute('data-ntd-size-gate');
      btn.removeAttribute('data-ntd-gate-next');
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      if (label && window.variantStrings && window.variantStrings.addToCart) label.textContent = window.variantStrings.addToCart;
    }
  }

  function fieldOf(sel) {
    return sel ? sel.closest('.product-form__input') || sel.closest('variant-selects') || sel : null;
  }

  function clearGuide(sel) {
    var field = fieldOf(sel);
    if (!field) return;
    field.classList.remove('ntd-needs-choice');
    var msg = field.querySelector('[data-ntd-choice-msg]');
    if (msg) msg.remove();
  }

  // Bring the shopper to the next missing choice and say what to pick.
  // Never makes the choice for them. Returns false when nothing is missing.
  window.ntdGateGuide = function () {
    var btn = submitButton();
    var next = btn && btn.getAttribute('data-ntd-gate-next');
    var sel = next === 'size' ? sizeSelect() : next === 'screws' ? screwSelect() : null;
    var field = fieldOf(sel);
    if (!field) return false;
    field.classList.add('ntd-needs-choice');
    var msg = field.querySelector('[data-ntd-choice-msg]');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'ntd-choice-msg';
      msg.setAttribute('data-ntd-choice-msg', '');
      msg.setAttribute('role', 'alert');
      field.appendChild(msg);
    }
    msg.textContent = next === 'size' ? SIZE_MSG : SCREWS_MSG;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    field.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    try {
      sel.focus({ preventScroll: true });
    } catch (e) {
      sel.focus();
    }
    return true;
  };

  // Taps (and Enter-key submits, which click the default button) on the gated
  // button: stop them before any submit fires and guide instead.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target && event.target.closest && event.target.closest('.product-form__submit[data-ntd-size-gate]');
      if (!btn) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.ntdGateGuide();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (!t || !t.matches) return;
      if (t.matches('variant-selects select[name="options[Size]"]') && t.value !== '') {
        sizeChosen = true;
        // Dawn's updateSelectionMetadata (runs after this capture listener) looks
        // for the option carrying the selected attribute and calls
        // removeAttribute on it; that is still the placeholder, so remove the
        // placeholder only after Dawn's handler has moved the attribute.
        setTimeout(function () {
          var ph = t.querySelector('[data-ntd-size-placeholder]');
          if (ph) ph.remove();
        }, 0);
        refresh();
      } else if (t.matches('select[name="properties[Buckle screws]"]')) {
        refresh();
      }
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(refresh, 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
